<script>
	import { optionBadgeStyle } from "./StatusBadgeItem.svelte";

	export let item = undefined;
	// Prop svelte-select passes to every Selection component.
	export const getSelectionLabel = undefined;
</script>

<span class="status-badge" style={optionBadgeStyle(item)}>
	{item.label.toUpperCase()}
</span>

<style>
	.status-badge {
		display: inline-block;
		vertical-align: middle;
		border-radius: 4px;
		padding: 4px 8px;
		font-size: 12px;
		font-weight: bold;
		line-height: 16px;
		white-space: nowrap;
	}
</style>
